import axios from '@/libs/api.request'
import {genURLParams} from '@/libs/urlparamhelper';

export const getAll = (params, urlParams) => {
  return axios.request({
    url: '/da/wirelessdata/getall' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getPage = (params, urlParams) => {
  return axios.request({
    url: '/da/wirelessdata/' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getSignLessThanTen = (params, urlParams) => {
  return axios.request({
    url: '/da/wirelessdata/getsignlessthanten' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getGPSLessThanTen = (params, urlParams) => {
  return axios.request({
    url: '/da/wirelessdata/getgpslessthanten' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

